import { camelizeKeys } from 'humps';
import mapValues from 'lodash/mapValues';

export const mergeJsonArray = (state, data) =>
  data.reduce((newState, item) => {
    const jsItem = mapValues(camelizeKeys(item), (jsonItem) => {
      try {
        return JSON.parse(jsonItem);
      } catch (e) {
        return jsonItem;
      }
    });
    return newState.merge({
      [item.id]: {
        ...jsItem,
        _merged: Date.now(),
      },
    });
  }, state);
